import { c as _c } from "react/compiler-runtime";
import { create } from "zustand";
import type { PaymentsTabKey } from "@/types/payments";
type PaymentsSearchStore = {
  terms: Record<PaymentsTabKey, string>;
  setTerm: (category: PaymentsTabKey, value: string) => void;
};
const INITIAL_TERMS: Record<PaymentsTabKey, string> = {
  telecollections: "",
  missing_card_payments: "",
  national_transfers: ""
};
export const usePaymentsSearchStore = create<PaymentsSearchStore>(set => ({
  terms: INITIAL_TERMS,
  setTerm: (category, value) => set(state => ({
    terms: {
      ...state.terms,
      [category]: value
    }
  }))
}));
export const usePaymentsSearchTerm = category => {
  const $ = _c(2);
  let t0;
  if ($[0] !== category) {
    t0 = state => state.terms[category];
    $[0] = category;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return usePaymentsSearchStore(t0);
};